<!-- Card.svelte -->
<script lang="ts">
  import { cn } from "$lib/utils/index"

  export let variant: "default" | "elevated" = "default"
  export let padding: "none" | "normal" | "large" = "normal"
  export let className = ""

  const baseStyles = "rounded-lg border border-gray-200"
  const variantStyles = {
    default: "bg-base-100",
    elevated: "bg-base-100 shadow-lg",
  }
  const paddingStyles = {
    none: "p-0",
    normal: "p-4",
    large: "p-6",
  }

  $: classes = cn(
    baseStyles,
    variantStyles[variant],
    paddingStyles[padding],
    className,
  )
</script>

<div class={classes}>
  <slot />
</div>
